
const initialState = {};

const UiReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'UI':
            //console.log('UiReducer', action.payload);
            return { ...state, ...((typeof action.payload == 'object') ? action.payload : {}) };
        default:
            return { ...state, ...action.payload };
    }
}

export default UiReducer;